var MoveDocumentFolderController = /** @class */ (function () {
    /*@ngInject*/
    function MoveDocumentFolderController($rootScope, MESSAGECONSTANTS, documentService, alertsAndNotificationsService, documentActionService) {
        this.$rootScope = $rootScope;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.documentService = documentService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.documentActionService = documentActionService;
    }
    MoveDocumentFolderController.prototype.$onInit = function () {
        this.userId = this.$rootScope.userDetails.id;
        this.savingFlag = false;
        this.context = this.folder ? "moveFolder" : "moveDocument";
        if (this.document) {
            this.documentFromFolderName = this._getFolderName(this.document.folderId, 'folderName');
            this.documentFromFolderParentName = this._getFolderName(this.document.folderId, 'parentFolderName');
            this.documentActionService.setParentAndChildFolderName(this.allFolders, this.document);
        }
    };
    MoveDocumentFolderController.prototype.save = function () {
        this.documentFolderForm.$submitted = true;
        if (this.context === "moveFolder") {
            this._moveFolder();
        }
        else {
            this._moveDocument();
        }
    };
    MoveDocumentFolderController.prototype._moveFolder = function () {
        var _this = this;
        var folderToMove = this.folder;
        delete folderToMove.active;
        delete folderToMove.documents;
        delete folderToMove.folders;
        delete folderToMove.showActions;
        delete folderToMove.parentFolderName;
        if (!this.documentFolderForm.$invalid) {
            this.savingFlag = true;
            if (this.folder.parentFolderId === "root") {
                folderToMove.parentFolderId = null;
            }
            this.documentService.updateCandidateDocumentFolder(folderToMove, function (data) {
                _this._setFolder(data);
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
            });
        }
    };
    MoveDocumentFolderController.prototype._setFolder = function (folder) {
        this.folder = folder;
        this.savingFlag = false;
        if (this.saveCallback) {
            this.saveCallback({ folder: this.folder });
        }
    };
    MoveDocumentFolderController.prototype._moveDocument = function () {
        var _this = this;
        if (!this.documentFolderForm.$invalid) {
            this.savingFlag = true;
            this.document.shareDocument = this.document.shared;
            this.document.documentId = this.document.id;
            this.document.sharedEntityIds = this.document.shared ? this.document.sharedEntityIds.join(",") : null;
            this.document.candidateType = this.candidateType;
            this.document.userId = this.userId;
            this.document.fromFolderName = this.documentFromFolderName;
            this.document.fromFolderParentName = this.documentFromFolderParentName;
            this.document.toFolderName = this._getFolderName(this.document.folderId, 'folderName');
            this.document.toFolderParentName = this._getFolderName(this.document.folderId, 'parentFolderName');
            if (this.candidateDetails.jobMatchId) {
                this.document.jobMatchId = this.candidateDetails.jobMatchId;
            }
            this.documentService.updateCandidateDocumentData(this.document, function (data) {
                _this.alertsAndNotificationsService.showBannerMessage("Document moved successfully.", "success");
                if (_this.saveCallback) {
                    _this.saveCallback({ document: _this.document });
                }
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
            });
        }
    };
    MoveDocumentFolderController.prototype.cancel = function () {
        if (this.cancelCallback) {
            this.cancelCallback();
        }
    };
    MoveDocumentFolderController.prototype._getFolderName = function (folderId, name) {
        if (name == 'folderName') {
            return this.allFolders.filter(function (folder) { return folder.id == folderId; })[0].name;
        }
        else {
            return this.allFolders.filter(function (folder) { return folder.id == folderId; })[0].parentFolderName;
        }
    };
    return MoveDocumentFolderController;
}());
MoveDocumentFolderController.$inject = ['$rootScope', 'MESSAGECONSTANTS', 'documentService', 'alertsAndNotificationsService', 'documentActionService'];
// import * as TEMPLATE from './move-document-folder.html';
import * as TEMPLATE from 'raw-loader!./move-document-folder.html';
export var MoveDocumentFolderComponent = {
    selector: 'moveDocumentFolder',
    component: {
        bindings: {
            folder: '<',
            document: '<',
            parentFolders: '<',
            allFolders: '<',
            candidateType: '<',
            candidateDetails: '<',
            saveCallback: '&',
            cancelCallback: '&'
        },
        controller: MoveDocumentFolderController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateprofile/candidateProfile/candidateDocuments/moveDocumentFolder/move-document-folder.html'
    }
};
//# sourceMappingURL=move-document-folder.component.js.map